import { BookVariantIcon } from './BookVariantIcon';

/**
 * author: Google
 * id 1B9F45CE-CA39-4ACF-8961-4B4B56D6F94A
 * name book-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-variant.svg
 * tags
 */
export const ClassIcon = BookVariantIcon;
export default ClassIcon